export default "__VITE_ASSET__kgN5O2LD__"